module.exports = __webpack_public_path__ + "img/06ed73dfeac1c7da9755c244364c9b4c.743de0e3.png";